import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { WidgetTeacherSectionList } from '@/homework/models/widget-teacher-section-list.model';
import { Status } from '@/models/status.model';
import { HOMEWORKS_EVENTS } from '@/homework/values/homeworks.values';
import { TEACHER_PORTAL_KEYS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { LocalStorageService } from '@/services/local-storage.service';
import ToolService from '@/providers/tools';

@Component({})
export default class EdHomeworkTeacherSectionList extends Vue {

  @Prop() readonly widgetSectionList: WidgetTeacherSectionList;

  public sectionsStatus: Status = new Status();

  get name(): string {
    return ToolService.exitSpecialChars(this.widgetSectionList.name);
  }

  get selected(): boolean {
    let sectionSelected: WidgetTeacherSectionList = this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.sectionSelected;
    if(sectionSelected) {
      return (this.widgetSectionList.id == sectionSelected.id && this.widgetSectionList.classId == sectionSelected.classId && this.widgetSectionList.courseId == sectionSelected.courseId);
    } else {
      return false;
    }
  }

  selectSection() {
    this.$edEventBus.$emit(HOMEWORKS_EVENTS.LOAD_SECTION_TEACHER_WIDGET, {section: this.widgetSectionList, isReload: false});
  }

  public getSectionLocalStorage() {
    let sectionId = LocalStorageService.getItem(TEACHER_PORTAL_KEYS.TASKS_HOMEWORK_ID);
    if(sectionId == this.widgetSectionList.id && !this.selected) {
      this.selectSection()
      LocalStorageService.removeItem(TEACHER_PORTAL_KEYS.TASKS_HOMEWORK_ID);
    }
  }

  created() {
    this.getSectionLocalStorage();
  }

}